import {
  Button,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  Text,
  useClipboard,
  useToast,
} from "@chakra-ui/react";
import { agendaFeedUrl, agendaFeedWebcalUrl } from "../api/agendaFeedApi";
import {
  useAgendaFeedQuery,
  useAtivarAgendaFeedMutation,
  useDesativarAgendaFeedMutation,
  useRegenerarAgendaFeedMutation,
} from "../hooks/useAgendaFeed";

// "Outros calendários": link .ics que o médico assina no Apple Calendar, Outlook, Google
// Agenda (por URL) ou qualquer app compatível. Inclui plantões e recebimentos previstos.
export default function AgendaFeedSection() {
  const toast = useToast();
  const feedQuery = useAgendaFeedQuery();
  const ativar = useAtivarAgendaFeedMutation();
  const regenerar = useRegenerarAgendaFeedMutation();
  const desativar = useDesativarAgendaFeedMutation();

  const feed = feedQuery.data;
  const url = feed?.ativo ? agendaFeedUrl(feed.path) : "";
  const { onCopy, hasCopied } = useClipboard(url);

  const erro = (title) => (error) =>
    toast({
      title,
      description: error.response?.data?.mensagem,
      status: "error",
      duration: 5000,
      isClosable: true,
    });

  const handleRegenerar = () => {
    if (
      !window.confirm(
        "Gerar um novo link? O link atual para de funcionar e será preciso assinar a agenda de novo nos apps em que ela foi adicionada.",
      )
    ) {
      return;
    }
    regenerar.mutate(undefined, {
      onSuccess: () => toast({ title: "Novo link gerado", status: "success", duration: 4000 }),
      onError: erro("Não foi possível gerar um novo link"),
    });
  };

  return (
    <Stack spacing={3}>
      <Stack spacing={1}>
        <Text fontWeight="semibold" fontSize="sm">
          Outros calendários (Apple, Outlook e outros)
        </Text>
        <Text fontSize="sm" color="app-muted-fg">
          Assine este link no seu app de agenda para ver seus plantões e recebimentos previstos. A
          atualização é feita pelo próprio app e pode levar algumas horas.
        </Text>
      </Stack>

      {feed?.ativo ? (
        <>
          <InputGroup size="sm">
            <Input value={url} isReadOnly pr="5.5rem" aria-label="Link da agenda" />
            <InputRightElement width="5.5rem">
              <Button size="xs" onClick={onCopy}>
                {hasCopied ? "Copiado" : "Copiar"}
              </Button>
            </InputRightElement>
          </InputGroup>
          <Text fontSize="xs" color="app-muted-fg">
            Quem tiver este link consegue ver sua agenda de plantões — não compartilhe.
          </Text>
          <HStack spacing={2} flexWrap="wrap">
            <Button as="a" href={agendaFeedWebcalUrl(feed.path)} size="sm">
              Abrir no app de agenda
            </Button>
            <Button
              size="sm"
              variant="outline"
              isLoading={regenerar.isPending}
              onClick={handleRegenerar}
            >
              Gerar novo link
            </Button>
            <Button
              size="sm"
              variant="ghost"
              isLoading={desativar.isPending}
              onClick={() =>
                desativar.mutate(undefined, { onError: erro("Não foi possível desativar") })
              }
            >
              Desativar
            </Button>
          </HStack>
        </>
      ) : (
        <Button
          size="sm"
          alignSelf="flex-start"
          isLoading={feedQuery.isLoading || ativar.isPending}
          onClick={() =>
            ativar.mutate(undefined, { onError: erro("Não foi possível gerar o link") })
          }
        >
          Gerar link da agenda
        </Button>
      )}
    </Stack>
  );
}
